export enum Providers {
    memsource = 'memsource',
    tempo = 'tempo',
    xtrf = 'xtrf',
}

export type ProvidersType = keyof typeof Providers
